import React from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import StatsSection from "./StatsSection";
import ServicesSection from "./ServicesSection";
import AudienceSection from "./AudienceSection";
import DemographicsSection from "./DemographicsSection";
import StudioBreakSection from "./StudioBreakSection";
import WhyChooseSection from "./WhyChooseSection";
import AccessSection from "./AccessSection";
import ClientsSection from "./ClientsSection";
import TestimonialsSection from "./TestimonialsSection";
import YouTubeSection from "./YouTubeSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <HeroSection />
      <StatsSection />
      <ServicesSection />
      <AudienceSection />
      <DemographicsSection />
      <StudioBreakSection />
      <WhyChooseSection />
      <AccessSection />
      <ClientsSection />
      <TestimonialsSection />
      <YouTubeSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;